/**
 * Analytics Service (GTM DataLayer)
 * Centraliza o disparo de eventos para o Google Tag Manager.
 */

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const analytics = {
  /**
   * Dispara um evento personalizado para o DataLayer
   */
  trackEvent: (eventName: string, params: Record<string, any> = {}) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        ...params,
        timestamp: new Date().toISOString(),
      });
      
      if (import.meta.env.DEV) {
        console.log(`[Analytics] Event: ${eventName}`, params);
      }
    }
  },

  /**
   * Eventos Pré-definidos
   */
  
  // Quando um usuário realiza uma busca
  trackSearch: (query: string, category?: string, state?: string) => {
    analytics.trackEvent('search', {
      search_term: query,
      search_category: category || 'all',
      search_state: state || 'all'
    });
  },

  // Quando um usuário clica para reivindicar um perfil (Lead)
  trackProfileClaim: (tenantId: string, businessName: string) => {
    analytics.trackEvent('claim_profile_click', {
      tenant_id: tenantId,
      business_name: businessName
    });
  },

  // Quando um usuário visualiza um perfil de empresa
  trackProfileView: (tenantId: string, businessName: string) => {
    analytics.trackEvent('profile_view', {
      tenant_id: tenantId,
      business_name: businessName
    });
  }
};
